import { cva, type VariantProps } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex cursor-pointer select-none items-center justify-center gap-2 whitespace-nowrap border-0 font-semibold leading-none no-underline transition-press not-disabled:active:scale-97 disabled:cursor-not-allowed disabled:opacity-60',
  {
    variants: {
      variant: {
        default: 'bg-surface-3 text-ink not-disabled:hover:bg-surface-4',
        primary: 'bg-accent text-accent-ink not-disabled:hover:bg-accent-hover',
        ghost:
          'bg-transparent text-muted not-disabled:hover:bg-surface-2 not-disabled:hover:text-ink',
        danger:
          'bg-danger-soft text-danger-text not-disabled:hover:bg-danger not-disabled:hover:text-danger-ink',
        ink: 'bg-field-ink text-white not-disabled:hover:bg-black',
        google:
          'bg-google-bg font-medium text-google-ink inset-ring inset-ring-google-border not-disabled:hover:bg-surface-2',
        link: 'h-auto bg-transparent p-0 font-medium text-ink underline underline-offset-3 not-disabled:active:scale-100',
      },
      size: {
        sm: 'h-7.5 rounded-control px-2.5 text-control',
        md: 'h-9 rounded-control px-3.5 text-body',
        field: 'h-10 rounded-control px-3.5 text-body',
        lg: 'h-12 rounded-control-lg px-4.5 text-body-lg',
        icon: 'h-8 rounded-control px-2 text-body',
        inline: 'h-auto p-0',
      },
      isBlock: { true: 'w-full', false: '' },
    },
    defaultVariants: { variant: 'default', size: 'md', isBlock: false },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
